import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AI_HEARD_ABOUT, HEARD_ABOUT_OPTIONS } from '@/lib/discoverySources';

export default function HeardAboutUsFields({ idPrefix, source, query, onChange }) {
  return (
    <>
      <div>
        <Label htmlFor={`${idPrefix}-heard`}>How did you hear about us? (optional)</Label>
        <select
          id={`${idPrefix}-heard`}
          value={source}
          onChange={(e) => onChange('self_reported_source', e.target.value)}
          className="mt-1 flex h-9 w-full rounded-md border border-input bg-card px-3 text-sm"
        >
          <option value="">Prefer not to say</option>
          {HEARD_ABOUT_OPTIONS.map((option) => <option key={option} value={option}>{option}</option>)}
        </select>
      </div>
      {AI_HEARD_ABOUT.includes(source) && (
        <div>
          <Label htmlFor={`${idPrefix}-ai-query`}>What did you ask {source}? (optional)</Label>
          <Input
            id={`${idPrefix}-ai-query`}
            value={query}
            maxLength={300}
            onChange={(e) => onChange('self_reported_query', e.target.value)}
            placeholder="e.g. box truck insurance for a new MC"
            className="mt-1"
          />
        </div>
      )}
    </>
  );
}